var map = {
	"./ais-uat-2024.09.01-errata1.json": "8503",
	"./ksa-uat-letter-2024.09.01-errata1.json": "64f4",
	"./ksa-uat-refund-2024.09.01-errata1.json": "78b5",
	"./ksa-uat-rtp-2024.09.01-errata1.json": "7700",
	"./pis-uat-2024.09.01-errata1.json": "9fdb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "527d";